const state= {

    Loadings:{
        list:true,
        general:false,
        item:false,
        status:false,
    },
    Item:null
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    contractId : (state) => state.contractId,
    Item : (state) => state.Item,
};

const actions = {
    async updateKPIActual({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/orders/kpi/${params.id}`, {
                method: "PUT",
                data : params.data,
                headers: {
                  Accept: "application/json",
                },
              })
                .then(response => {
                    commit('OrderController/updateKPIActual',response.data.data, { root: true });
                    resolve(response)
                })
                .catch(error => reject( error ));
        });
    },
 
};

const mutations = {
    setItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit );
        state.Items.data = data.items;
        state.Items.total = data.total;
        state.Items.pages = data.pages;
    },
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}